import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import type { OfferList } from 'types/api'
import { BaseParams, BaseResponse } from 'types/utils'

export const offersQueryKey = ['offers']

export function useOffers({
  params
}: BaseParams<{ user?: string; flat?: string }> = {}) {
  const [searchParams] = useSearchParams()
  const search = searchParams.get('search')
  const ordering = searchParams.get('ordering')
  const limit = searchParams.get('limit')
  const offset = searchParams.get('offset')
  const status = searchParams.get('status')
  const createdFrom = searchParams.get('created_from')
  const createdTo = searchParams.get('created_to')
  const rentMin = searchParams.get('rent_min')
  const rentMax = searchParams.get('rent_max')
  const location = searchParams.get('location')

  async function getOffers() {
    const response = await apiClient.get<BaseResponse<OfferList>>(
      `${SNA_PREFIX}offers`,
      {
        params: {
          user: params?.user,
          flat: params?.flat,
          search,
          ordering,
          limit,
          offset,
          status,
          created_from: createdFrom,
          created_to: createdTo,
          rent_min: rentMin,
          rent_max: rentMax,
          location
        }
      }
    )

    return response.data
  }

  return useQuery({
    queryFn: getOffers,
    queryKey: [
      ...offersQueryKey,
      params?.user,
      params?.flat,
      search,
      ordering,
      limit,
      offset,
      status,
      createdFrom,
      createdTo,
      rentMin,
      rentMax,
      location
    ]
  })
}
